export enum LeaseStatusEnum {
  LEASE_ACTIVE = 'LEASE_ACTIVE',
  LEASE_EXPIRED = 'LEASE_EXPIRED',
  LEASE_CLOSED = 'LEASE_CLOSED'
}
